import React from 'react';
import Drawer from 'react-modern-drawer'
import { useDispatch, useSelector } from 'react-redux';
import { fileExtension, getMessageWithSeparator, getThumImage, niceBytes } from '../../../Utils/Common';
import { setActiveMsg, setPopup, update_messages } from '../../../redux/messageSlice';
import { useMutation } from '@apollo/client';
import { ATTACHMENT_STAR_MUTATION, File_view } from '../../../apollo/Mutations';
import Axios from 'axios';
const FileDownload = require('js-file-download');

const FileDrawer = ({ setFileViewPopup, type }) => {
    const dispatch = useDispatch();
    const { active_file, file_drawer, msgs, user, downloading_progress } = useSelector(state => state.message)
    const { active_discussion, active_task } = useSelector(state => state.task)

    const msg = active_task ? active_discussion.find(m => m.msg_id === active_file?.msg_id) : msgs.find(m => m.msg_id === active_file?.msg_id) || null;

    const [starMutation] = useMutation(ATTACHMENT_STAR_MUTATION);
    const starMarkFile = () => {
        starMutation({
            variables: {
                input: {
                    file_id: active_file?.id,
                    is_reply_msg: active_file?.main_msg_id ? 'yes' : 'no',
                }
            }
        })
        if (msg?.msg_type.indexOf('discussion') > -1) {
            // dispatch(update_active_discussion_msg({
            //     conversation_id: msg.conversation_id,
            //     msg_id: msg.msg_id,
            //     fields: {
            //         all_attachment: msg.all_attachment.map(f => f.id === file.id ? { ...f, star: f.star.indexOf(user?.id) > -1 ? [] : [user?.id] } : f)
            //     },
            //     is_reply_msg: msg.is_reply_msg,
            //     msg_type: msg.msg_type
            // }))
        } else {
            dispatch(update_messages({
                conversation_id: active_file?.conversation_id,
                msg_id: active_file?.msg_id,
                fields: {
                    all_attachment: msg?.all_attachment?.map(f => f.id === active_file?.id ? { ...f, star: f.star.indexOf(user?.id) > -1 ? [] : [user?.id] } : f)
                },
                is_reply_msg: msg?.is_reply_msg,
                msg_type: msg?.msg_type
            }))
        }
    }

    const AfileDownload = (url, filename) => {
        console.log(url, filename);

        dispatch(setPopup({ key: 'downloading_file', value: [filename] }))
        if (downloading_progress[filename]) return
        dispatch(setPopup({ key: 'downloading_progress', value: { ...downloading_progress, [filename]: 'Downloading...' } }))
        Axios({
            url: url,
            method: 'GET',
            responseType: 'blob',
            onDownloadProgress(progressEvent) {
                let progress = Math.floor((progressEvent.loaded / progressEvent.total) * 100) + "%";
                dispatch(setPopup({ key: 'downloading_progress', value: { ...downloading_progress, [filename]: progress } }))
            }
        }).then((response) => {
            FileDownload(response.data, filename);
            let d_progress = { ...downloading_progress };
            d_progress = { ...(delete d_progress[filename] && d_progress) }
            dispatch(setPopup({ key: 'downloading_progress', value: d_progress }))
        });
    }

    const openDelete = () => {
        if (msg) {
            if (msg.all_attachment.length > 1) {
                dispatch(setPopup({ key: 'delete_file', value: true }))
            } else {
                dispatch(setActiveMsg(msg));
                dispatch(setPopup({ key: 'delete_msg', value: true }))
            }
        } else {
            dispatch(setPopup({ key: 'delete_file', value: true }))
        }
    }

    const [fileViewMutation] = useMutation(File_view);

    const file_action = (msg, _f) => {
        if (_f.file_type.indexOf('image') > -1) {
            // setPreview_data(_f)
            // setPreview_all_data(msg.all_attachment.filter((i) => i.file_type.indexOf('image') > -1))
            setFileViewPopup(true)
        } else {
            localStorage.setItem('file_view', JSON.stringify(_f));
            window.open('/file', "_blank")
        }
        // else if (_f.file_type.indexOf('pdf') > -1) {
        // } else if (_f.file_type.indexOf('application') > -1 && _f.file_type.indexOf('pdf') === -1) {
        // } else if (_f.file_type.indexOf('video') > -1 || _f.file_type.indexOf('audio') > -1) {
        // }
    }

    const handleFileAction = async (type) => {
        if (type === 'star') {
            starMarkFile()
        } else if (type === 'tag') {
            dispatch(setPopup({ key: 'tag_popup', value: true }));
        } else if (type === 'download') {
            AfileDownload(active_file?.location, active_file?.originalname)
        } else if (type === 'forward') {
            dispatch(setPopup({ key: 'userList', value: { key: 'forward_file', state: true } }))
        } else if (type === 'share') {
            dispatch(setPopup({ key: 'linkShare_popup', value: true }))
        } else if (type === 'delete') {
            openDelete()
        } else if (type === 'fileView') {
            file_action(msg, active_file)
            fileViewMutation({ variables: { file_id: active_file?.id } })
        }
        dispatch(setPopup({ key: 'file_drawer', value: false }))
    }

    return (
        <Drawer
            open={file_drawer}
            onClose={() => dispatch(setPopup({ key: 'file_drawer', value: false }))}
            direction='bottom'
            enableOverlay={true}
            className='rounded-lg !-bottom-11 !h-auto px-1 pb-5 dark:!bg-teal-600'
            overlayClassName='customOverlay'
        >
            <div className=''>
                <div className="appBar "></div>
                <div className="popUpBtmContainer !mb-0">
                    <div className='flex justify-center'>
                        {active_file?.location.includes('blob:') ?
                            <img src={active_file?.location}
                                className="!w-max-[100%] !h-max-[100%] object-fill rounded-md"
                                loading='lazy' alt="img" />
                            :
                            <img src={
                                active_file?.file_type?.indexOf('image') > -1 && active_file?.file_type?.indexOf('svg') === -1
                                    ? getThumImage(active_file?.location)
                                    : active_file?.file_category?.indexOf('voice') > -1
                                        ? `/images/light_theme/voice.svg`
                                        // : workFtheme === 'dark'
                                        //     ? `/media/images/black_theme/${fileExtension(file?.originalname)}.svg`
                                        : `/images/light_theme/${fileExtension(active_file?.originalname)}.svg`
                            }
                                loading="lazy"
                                alt="file ext"
                                title="sender"
                                className="imageData"
                            />
                        }

                    </div>
                    <div className="btmPopUpChildText !mt-2">
                        <p className="File_ChildModalHeadText text-center px-4 break-words w-full max-w-full dark:text-white">{active_file?.originalname}</p>
                        <p className="File_ChildModalTitleSubText text-sm text-center px-4 dark:text-white">{niceBytes(active_file?.file_size)}, <span>Uploaded:&nbsp;</span><span>
                            {getMessageWithSeparator(active_file?.created_at)}</span>
                        </p>
                    </div>
                </div>
                <div className='p-5'>
                    <div className='flex items-center gap-2 border-b py-3 border-teal-200' onClick={() => handleFileAction('fileView')}>
                        <div className='w-6 h-6 relative'><div className='ImageView'></div></div>
                        <div className='text-teal-600 dark:text-white'>View</div>
                    </div>
                    <div className='flex items-center gap-2 border-b py-3 border-teal-200' onClick={() => handleFileAction('star')}>
                        <div className='w-6 h-6 relative'>
                            {active_file?.star?.includes(user?.id) ?
                                <div className='star_blue_icons'></div> :
                                <div className='star_outline_icons'></div>
                            }
                        </div>
                        <div className='text-teal-600 dark:text-white'>Add to Starred</div>
                    </div>
                    <div className='flex items-center gap-2 border-b py-3 border-teal-200' onClick={() => handleFileAction('tag')}>
                        <div className='w-6 h-6 relative'><div className='tags_outline_icons'></div></div>
                        <div className='text-teal-600 dark:text-white'>Add a tag</div>
                    </div>
                    <div className='flex items-center gap-2 border-b py-3 border-teal-200' onClick={() => handleFileAction('download')}>
                        <div className='w-6 h-6 relative'><div className='download_outline_icons'></div></div>
                        <div className='text-teal-600 dark:text-white'>Download</div>
                    </div>
                    {type !== 'task' && <div className='flex items-center gap-2 border-b py-3 border-teal-200' onClick={() => handleFileAction('forward')}>
                        <div className='w-6 h-6 relative'><div className='forwardIconsGray'></div></div>
                        <div className='text-teal-600 dark:text-white'>Forward</div>
                    </div>}
                    {(user?.id === active_file?.user_id && type !== 'task') &&
                        <div className='flex items-center gap-2 border-b py-3 border-teal-200' onClick={() => handleFileAction('share')}>
                            <div className='w-6 h-6 relative'><div className='shareGrayIcons'></div></div>
                            <div className='text-teal-600 dark:text-white'>Share</div>
                        </div>
                    }
                    {user?.id === active_file?.user_id &&
                        <div className='flex items-center gap-2 border-b py-3 border-teal-200' onClick={() => handleFileAction('delete')}>
                            <div className='w-6 h-6 relative'><div className='delete_Icons'></div></div>
                            <div className='text-teal-600 dark:text-white'>Delete</div>
                        </div>
                    }
                </div>
            </div>
        </Drawer>
    );
};

export default FileDrawer;